import { z } from 'zod';
/**
 * Lightweight graph entity reference — `{kind, key, label}` snapshot
 * used by memory-feed events, near-miss events, and any future
 * surface that needs a denormalized pointer to a graph entity
 * without dragging the full entity-resolution row through.
 *
 * `kind` is intentionally a free-form string here (not a closed enum)
 * because consumer domains have different valid kinds — memory uses
 * "person|customer|topic|...", near-miss uses "insight|dossier|..."
 * — and forcing a union would couple the domains.
 */
export const EntityRef = z.object({
    kind: z.string().min(1),
    key: z.string().min(1),
    label: z.string().min(1),
});
